import { useRootInstance } from './useRootInstance';

export const useVuex = () => {
  const vm = useRootInstance();
  if (!vm.$store) {
    Object.defineProperty(vm, '$store', {
      get: function get() {
        return this._store;
      }
    });
  }
  return vm.$store;
};

export const useGetter = (name: string) => {
  const vuex = useVuex();
  return vuex?.getters?.[name];
};
